/**
 * Reads a file and returns its data as a Data URL.
 * @param {File} file
 * @returns {Promise<string>}
 */
export function readFile(file) {
    return new Promise((resolve, reject) => {
        let fr = new FileReader();
        fr.onload = evt => {
            resolve(evt.target.result);
        };
        fr.readAsDataURL(file);
    });
}
